import React from 'react';
import PropTypes from 'prop-types';
OnboardingCompany.propTypes = {
    logo: PropTypes.string,
    name: PropTypes.string,
    id: PropTypes.string,
    onCompanyClick: PropTypes.func
};
export default function OnboardingCompany(_a) {
    var _b = _a.logo, logo = _b === void 0 ? '' : _b, _c = _a.name, name = _c === void 0 ? '' : _c, _d = _a.id, id = _d === void 0 ? '' : _d, _e = _a.onCompanyClick, onCompanyClick = _e === void 0 ? null : _e;
    return (React.createElement("div", { className: "company__single", onClick: function () { return onCompanyClick(id); } },
        React.createElement("div", { className: "company__inner" },
            React.createElement("div", { className: "company__image" },
                React.createElement("div", { className: "company__midimage" },
                    React.createElement("div", { className: "company__innerimage", style: { backgroundImage: "url(".concat(logo, ")") } }))),
            React.createElement("div", { className: "company__text" }, name))));
}
